import { userHasPermission } from "../swzutils/UserPermissionsUtil";
import { loggedInUserSelector } from "../store/slice/auth";
import { useAppSelector } from "../store";
const HasPermissions = (props) => {
    let user = useAppSelector(loggedInUserSelector);
    if (!userHasPermission(user, props.permissions)) {
        //console.log("permission not found:", this.props.permissions);
        return null;
    }
    return props.children;
};
export default HasPermissions;
